// AuthBack — the pill "Back" control used at the top of the auth screens.

import { useTranslation } from 'react-i18next';
import Icon from '@/components/common/Icon';

interface AuthBackProps {
  onClick: () => void;
}

const AuthBack = ({ onClick }: AuthBackProps) => {
  const { t } = useTranslation();

  return (
    <button type='button' className='auth-page__back' onClick={onClick}>
      <span className='auth-page__back-icon'>
        <Icon name='arrow-left' size={15} aria-hidden='true' />
      </span>
      {t('button_back')}
    </button>
  );
};

export default AuthBack;
